import { HStack, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
// import { getArchiveDetails } from "../../services/Archive";

export default function ProducerDetails({ archive, producerData }) {

  // Utility function to find an item by key
  const findItem = (items, key) => items?.find(item => item.key === key) || {};

  // Extract relevant film data
  const producerVal = findItem(producerData, "producer")?.value;
  const bannerVal = findItem(producerData, "banner")?.value;
  const directorVal = findItem(producerData, "director")?.value;

  const producers = {
    display: "Producer",
    value: producerVal,
  };

  const bannerData = {
    display: "Baneer",
    value: bannerVal,
  };

  const directorData = {
    display: "Director",
    value: directorVal,
  };

  // Handle routing on film click
  // const handleRoute = async (alias) => {
  //   try {
  //     const res = await getArchiveDetails(alias);
  //     if (res?.data) {
  //       const routeType = res.data.route_type !== "generic" ? res.data.route_type : "generic";
  //       navigate(`/${routeType}/${alias}/`);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching archive details:", error);
  //   }
  // };

  const dataArray = [
    { display: "Producer", value: producers?.value },
    { display: "Banner", value: bannerData?.value },
    { display: "Director", value: directorData?.value },
  ];

  return (
    <>
    <HStack gap={"5px"} flexWrap={"wrap"}>
      {dataArray.map((data, index) => (
        data?.value && (
          <Stack
            key={index}
            marginInlineStart={"0rem!important"}
            py="1"
            gap={"0"}
            className="mt-0 px-0"
            // flexDirection={"column"}
          >
            <HStack className="mt-0 px-0" width="max-content"
            >
              <Text
                fontSize={{ base: "12px", md: "16px" }}
                fontWeight="700"
                color="black"
              >
                {data?.display}
              </Text>
  
              {data?.value?.map((item, itemIndex) => (
                <Link key={item?.alias} 
                >
                  <Text
                    fontSize={{ base: "12px", md: "16px" }}
                    fontWeight="400"
                    color="color.blue"
                  >
                    {item.full_name} {/* or item.name if you prefer */}
                    {itemIndex < data?.value?.length - 1 && ','}
                  </Text>
                </Link>
              ))}
            </HStack>
          </Stack>
        )
      ))}
      </HStack>
    </>
  );
}
